<template>
  <table id="tabela-no-moving">
    <tr class="">
      <th class="text-truncate">Nível de Importância</th>

      <th v-for="(_, histograma) in dados_analise" :key="histograma" class="text-truncate">
        {{ histograma.substring(3) }}
      </th>

      <th class="text-truncate">Total Geral</th>
    </tr>

    <tr
      v-for="(_, nivel_servico) in DADOS_PRIMEIRA_CHAVE_OBJ_COMPUTED"
      :key="nivel_servico"
      class="text-truncate"
    >
      <td class="font-weight-medium text-left">{{ nivel_servico.substring(3) }}</td>

      <template v-for="(_, histograma) in dados_analise">
        <td
          :key="histograma"
          class="text-truncate cursor-pointer"
          @click="eventColunaClick({ nivel_servico, histograma })"
        >
          R$ {{ formatarValorComCasas(dados_analise[histograma][nivel_servico], 0) }}
        </td>
      </template>

      <td class="cursor-pointer" @click="eventColunaClick({ nivel_servico })">
        R$ {{ formatarValorComCasas(buscarTotalGeralHorizontal(nivel_servico), 0) }}
      </td>
    </tr>

    <tr class="text-truncate">
      <td class="font-weight-medium text-left">
        Total Geral
      </td>

      <td
        v-for="(_, histograma) in dados_analise"
        :key="histograma"
        class="cursor-pointer"
        @click="eventColunaClick({ histograma })"
      >
        R$ {{ formatarValorComCasas(buscarTotalGeralVertical(histograma), 0) }}
      </td>

      <td class="cursor-pointer" @click="eventColunaClick({})">R$ {{ formatarValorComCasas(TOTAL_GERAL_COMPUTED, 0) }}</td>
    </tr>
  </table>
</template>

<script setup>
import {useHelpers} from "@/components/indicadores/NoMovingV2/helpers";
import {formatarValorComCasas} from "@/helpers";
import {computed} from "vue";

const {histogramas} = useHelpers();

const props = defineProps({
  dados_analise: Object,
});

const emit = defineEmits(['click:coluna']);

const PRIMEIRA_CHAVE_OBJ_COMPUTED = computed(() => {
  const chaves = Object.keys(props.dados_analise);
  return chaves[0] || null;
});

const DADOS_PRIMEIRA_CHAVE_OBJ_COMPUTED = computed(() => {
  return props.dados_analise[PRIMEIRA_CHAVE_OBJ_COMPUTED.value]
    ? props.dados_analise[PRIMEIRA_CHAVE_OBJ_COMPUTED.value]
    : [];
});

const TOTAL_GERAL_COMPUTED = computed(() => {
  let valor = 0;

  Object.keys(props.dados_analise).forEach(histograma => {
    valor += Object.values(props.dados_analise[histograma]).reduce((a, b) => a + Number(b), 0);
  });

  return valor;
});

function buscarTotalGeralHorizontal(nivel_servico) {
  let valor = 0;

  Object.keys(props.dados_analise).forEach(histograma => {
    valor += Number(props.dados_analise[histograma][nivel_servico] || 0);
  });

  return valor;
}

function buscarTotalGeralVertical(histograma) {
  let valor = 0;

  Object.keys(props.dados_analise).forEach(chave => {
    if (histograma !== chave) return;
    valor = Object.values(props.dados_analise[histograma]).reduce((a, b) => a + Number(b), 0);
  });

  return valor;
}

function eventColunaClick(ev) {
  emit('click:coluna', ev);
}
</script>

<style scoped>
#tabela-no-moving {
  width: 100%;
  text-align: left;
  font-size: 12px;
  border-collapse: collapse;
  border-spacing: 0;
}
#tabela-no-moving tr th {
  font-weight: 600;
  padding: 5px 0 10px 0;
}
#tabela-no-moving tr td {
  padding: 4px 0;
  border-top: 1px solid #eaeaea;
}
</style>
